import perksGOTracking from "@irati-tracking/perksgo/perksGO"
import mainTheme from "@irati/ui/src/global/theme"

interface MenuItemsParams {
  showFidel: boolean,
  platformApp: boolean,
  showCustomisation: boolean
}

export default ({showFidel, platformApp, showCustomisation}: MenuItemsParams) => [
  {
    label: "account.profile.label",
    to: "/profile",
    id: "profileId"
  },
  {
    label: "account.contact.label",
    to: "/settings/contact",
    id: "contactPreferencesId"
  },
  {
    label: "account.payment.label",
    to: "/settings/payment",
    id: "myPaymentCardsId"
  },
  showFidel && {
    label: "account.linked.label",
    to: "/settings/linkedcards",
    id: "myLinkedCardsId",
    onClick: perksGOTracking.clickMyLinkedCards
  },
  {
    label: "account.password.label",
    to: "/settings/password",
    id: "changePasswordId"
  },
  {
    label: "account.security.label",
    to: "/settings/security",
    id: "securityId"
  },
  showCustomisation && {
    label: "account.customisation.interests.label",
    to: "/settings/customisation/categories",
    id: "customiseMyInterestsId"
  },
  {
    to: "/welcome/logout",
    label: "account.logout",
    id: "logoutId",
    color: mainTheme.colors.error,
    app: platformApp
  }
]
